import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import MobileUserServicePublic from '../services/public/MobileUserServicePublic';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class TokenAuthPage extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            response: {
                type: undefined,
                fontColor: undefined,
                message: undefined,
            },
        };
        this.service = new MobileUserServicePublic();
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.location.search);
        let token = searchParams.get('token');
        let email = searchParams.get('email');
        this.service
            .activateEmail({token: token, email: email})
            .then(() => {
                this.setState({
                    response: {
                        type: 'success',
                        fontColor: 'green',
                        message: t('message.confirmEmailSuccessfull'),
                    },
                });
            })
            .catch((ex) => {
                this.setState({
                    response: {
                        type: 'error',
                        fontColor: 'red',
                        message: ex.message,
                    },
                });
            });
        this.clearUrl();
    }

    clearUrl() {
        let url = window.location.href.toString();
        const splitUrl = url.split('?')[0];
        window.history.pushState({}, document.title, splitUrl);
    }

    prepareHeaderItems() {
        return [];
    }

    prepareFooterItems() {
        return [];
    }

    render() {
        const response = this.state.response;
        return (
            <div className='container-fluid'>
                <React.Fragment>
                    <h1>
                        <label style={{color: `${response?.fontColor}`}}>{t('message.' + response?.type)}</label>
                    </h1>
                    <h4>
                        <p>
                            <label>{response?.message}</label>
                        </p>
                    </h4>
                </React.Fragment>
            </div>
        );
    }
}

TokenAuthPage.defaultProps = {
    viewMode: 'EDIT',
};

TokenAuthPage.propTypes = {
    viewMode: PropTypes.string.isRequired,
};

export default withRouter(withTranslation()(TokenAuthPage));
